export default "__VITE_ASSET__CmC_VuhZ__"